module.exports = __webpack_public_path__ + "0f7d23d9fbd4395be7489e24ea35d835.png";